import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";

// Get Table Data
export const WaterAuditTableDataAPI = createAsyncThunk("WaterAuditTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_JunctionID,
        M_UserID,
        Flag,
        From,
        To,
        token,
        DashProjectTypeId,
        RoleID,
        handleWaterAuditExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterAudit_Select?FromDate=${FromDate}&ToDate=${ToDate}&M_WardID=${M_WardID}&M_Distri_WS_LocationID=${M_WS_JunctionID}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterAudit_Select?FromDate=${FromDate}&ToDate=${ToDate}&M_WardID=${M_WardID}&M_WS_JunctionID=${M_WS_JunctionID}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleWaterAuditExport && handleWaterAuditExport()
                return result.data
            } else {
                return result
            }
        })
})

const WaterAuditTableDataSlice = createSlice({
    name: "WaterAuditTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterAuditTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterAuditTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterAuditTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WaterAuditTableDataReducer = WaterAuditTableDataSlice.reducer


export const WaterAuditExportTableDataAPI = createAsyncThunk("WaterAuditExportTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_JunctionID,
        M_UserID,
        Flag,
        From,
        To,
        token,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterAudit_Select?FromDate=${FromDate}&ToDate=${ToDate}&M_WardID=${M_WardID}&M_Distri_WS_LocationID=${M_WS_JunctionID}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterAudit_Select?FromDate=${FromDate}&ToDate=${ToDate}&M_WardID=${M_WardID}&M_WS_JunctionID=${M_WS_JunctionID}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterAuditExportTableDataSlice = createSlice({
    name: "WaterAuditExportTableData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterAuditExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WaterAuditExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(WaterAuditExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WaterAuditExportTableDataReducer = WaterAuditExportTableDataSlice.reducer


export const WaterAuditPostDataAPI = createAsyncThunk("WaterAuditPostData", async ({ data }) => {
    const {
        T_WS_WaterAuditID,
        T_Distri_WaterAuditID,
        RecivedWaterMLD,
        SupplyWaterMLD,
        Non_RevenueWaterMLD,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterAuditID", T_Distri_WaterAuditID);
    } else {
        formdata.append("T_WS_WaterAuditID", T_WS_WaterAuditID);
    }

    formdata.append("RecivedWaterMLD", RecivedWaterMLD);
    formdata.append("SupplyWaterMLD", SupplyWaterMLD);
    formdata.append("Non_RevenueWaterMLD", Non_RevenueWaterMLD);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_Distri_WaterAudit_Update`
    } else {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_WS_WaterAudit_Update`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const WaterAuditPostDataSlice = createSlice({
    name: "WaterAuditPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterAuditPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterAuditPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterAuditPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterAuditPostDataReducer = WaterAuditPostDataSlice.reducer

// -----------------Delete API ---------------

export const WaterAuditDeleteAPI = createAsyncThunk("WaterAuditDelete", async ({ data }) => {
    const {
        T_WS_WaterAuditID,
        T_Distri_WaterAuditID,
        M_UserID,
        token,
        handleIsPost,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    // var formdata = new FormData();
    // formdata.append("T_WS_WaterAuditID", "1");
    // formdata.append("M_UserID", "1");

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterAuditID", T_Distri_WaterAuditID);
    } else {
        formdata.append("T_WS_WaterAuditID", T_WS_WaterAuditID);
    }
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_Distri_WaterAudit_Delete`
    } else {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_WS_WaterAudit_Delete`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const WaterAuditDeleteSlice = createSlice({
    name: "WaterAuditDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterAuditDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WaterAuditDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(WaterAuditDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterAuditDeleteReducer = WaterAuditDeleteSlice.reducer